var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ErrorPage"},[_c('div',{staticClass:"pageText"},[_c('div',{staticClass:"text"},[_vm._v("权限不足请联系后台管理员")])])])
}]

export { render, staticRenderFns }